// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__Agk0e"};